@if (selectedMethod() === smsType || selectedMethod() === emailType) {
  <div class="rounded-md border border-gray-300 bg-gray-50 p-2 sm:p-3">
    <div class="placeholder">
      <p>{{ txtDescription() }}</p>
    </div>
  </div>
} @else {
  @if (isInitializing()) {
    <div class="flex flex-col items-center p-8">
      <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
    </div>
  }
  @if (!isInitializing() && totpSecret()) {
    <div class="rounded-md border border-gray-300 bg-gray-50 p-2 sm:p-3 mb-2">
      <div class="font-bold">Scan this QR code (recommended):</div>
      <div class="placeholder mt-2">
        <qrcode [qrdata]="otpAuthUrl()" [width]="qrSize()" [errorCorrectionLevel]="'M'" [alt]="'TOTP QR code'">
        </qrcode>
      </div>
    </div>
    <div class="rounded-md border border-gray-300 bg-gray-50 p-2 sm:p-3">
      <div class="font-bold">Or enter this secret code manually:</div>
      <p class="px-4 break-words flex items-center">
        <span class="min-w-0 flex-1 break-words">{{ totpSecret() }}</span>

        <button
          color="secondary"
          mat-icon-button
          extended
          [cdkCopyToClipboard]="totpSecret()"
          matTooltip="Copy Billing info"
          class="flex items-center justify-center ml-2 flex-shrink-0">
          <mat-icon class="text-gray-500">content_copy</mat-icon>
        </button>
      </p>
    </div>
  }
}
